const initialState = {
  resultsBookingsList: [],
  resultsBooking: {},
  resultsBookingNoteAdd: {},
  resultsBookingNotePatch: {},
  resultsBookingNoteDelete: {},
  resultsBookingNote: {},
  resultsBookingNotesList: {},
  resultsBookingLogAdd: {},
  resultsBookingLogPatch: {},
  resultsBookingUpdate: {},
  resultsBookingLogDelete: {},
  resultsBookingLogGet: {},
  resultsBookingLogsList: [],
  resultCancelBooking: null,
  resultRefundBooking: null,
  refreshBooking: false,
  resultsBookingResend: false,
  resultsBookingMetasList: [],
  resultsBookingsListByMonth: {},
  resultsPaymentNowBooking: {},
  resultsBookingNotesTaskCount: {}

};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_BOOKING_RESPONSE_GET":
      const monthKey = action.monthKey;
      if (monthKey) {
        newState.resultsBookingsListByMonth = {
          ...(newState.resultsBookingsListByMonth || {}),
          [monthKey]: action.value
        };
      } else {
        newState.resultsBookingsList = action.value;
      }
      break;
    case "GET_BOOKING":
      newState.resultsBooking = {};
      newState.refreshBooking = false;
      newState.resultsBookingResend = false;
      break;
    case "BOOKING_RESPONSE_GET":
      newState.resultsBooking = action.value;
      break;
    case "BOOKING_RESPONSE_RESEND":
      newState.resultsBookingResend = action.value;
      break;
    case "RESET_RESPONSE_RESEND":
      newState.resultsBookingResend = false;
      break;
    case "BOOKING_RESPONSE_UPDATE":
      newState.resultsBookingUpdate = action.value;
      break;
    case "RESET_RESPONSE_UPDATE":
      newState.resultsBookingUpdate = {};
      break;
    case "BOOKING_METAS_RESPONSE_GET":
      newState.resultsBookingMetasList = action.value;
      break;

    //NOTE/TASK
    case "BOOKING_NOTE_RESPONSE_ADD":
      newState.resultsBookingNoteAdd = action.value;
      break;
    case "BOOKING_NOTE_RESPONSE_UPDATE":
      newState.resultsBookingNotePatch = action.value;
      break;
    case "BOOKING_NOTE_RESPONSE_DELETE":
      newState.resultsBookingNoteDelete = action.value;
      break;
    case "BOOKING_NOTE_RESPONSE_GET":
      newState.resultsBookingNote = action.value;
      break;
    case "BOOKING_NOTES_RESPONSE_GET":
      newState.resultsBookingLogsList = action.value;
      break;
    case "RESET_NOTE_RESPONSES":
      newState.resultsBookingNoteAdd = {};
      newState.resultsBookingNotePatch = {};
      newState.resultsBookingNoteDelete = {};
      newState.resultsBookingNote = {};
      break;
    //LOGS
    case "BOOKING_LOG_RESPONSE_ADD":
      newState.resultsBookingLogAdd = action.value;
      break;
    case "BOOKING_LOG_RESPONSE_UPDATE":
      newState.resultsBookingLogPatch = action.value;
      break;
    case "BOOKING_LOG_RESPONSE_DELETE":
      newState.resultsBookingLogDelete = action.value;
      break;
    case "BOOKING_LOG_RESPONSE_GET":
      newState.resultsBookingLogGet = action.value;
      break;
    case "BOOKING_LOGS_RESPONSE_GET":
      newState.resultsBookingLogsList = action.value;
      break;
    case "RESET_LOG_RESPONSES":
      newState.resultsBookingLogAdd = {};
      newState.resultsBookingLogPatch = {};
      newState.resultsBookingLogDelete = {};
      newState.resultsBookingLogGet = {};
      break;
    case "CANCEL_BOOKING":
      newState.resultCancelBooking = null;
      break;
    case "RESET_CANCEL_RESPONSES":
      newState.resultCancelBooking = null;
      break;
    case "BOOKING_RESPONSE_CANCEL":
      newState.resultCancelBooking = action.value;
      newState.refreshBooking =
        action.value?.responseStatus === "error" ? false : true;
      break;
    case "REFUND_BOOKING":
      newState.resultRefundBooking = null;
      break;
    case "BOOKING_RESPONSE_REFUND":
      newState.resultRefundBooking = action.value;
      newState.refreshBooking =
        action.value?.responseStatus === "error" ? false : true;
      break;
    case "RESET_REFUND_RESPONSES":
      newState.resultRefundBooking = null;
      break;
    case "RESET_RESEND_RESPONSES":
      newState.resultsBookingResend = false;
      break;
    case "BOOKINGS_RESPONSE_RESET":
      newState.resultsBookingsListByMonth = {};
      break;
    case "PAYMENT_NOW_BOOKING":
      newState.resultsPaymentNowBooking = action.value;
      break;
    case "RESET_PAYMENTNOW_RESPONSES":
      newState.resultsPaymentNowBooking = {};
      break;
    case "LIST_BOOKING_NOTES_TASK_COUNT_RESPONSE_GET":
      newState.resultsBookingNotesTaskCount = action.value;
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
